import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';
import axios from 'axios';
import { Container, Row, Col } from 'reactstrap';
import { Toast } from 'primereact/toast';

const HeaderBanner = () => {

    const cookies = useMemo(() => new Cookies(), []);
    let navigate = useNavigate();
    const toast = useRef(null);

    useEffect(() => {
        if (cookies.get('id')) {
            navigate('/');
        }
        document.documentElement.style.fontSize = 12 + 'px';
    }, [cookies, navigate]);

    const styles = {
        principal: {
            width: '100%',
            height: '1180px',
            minHeight: '100vh',
        },
        headerTitle: {
            fontWeight: '800', // Agregar negrita al texto
            fontFamily: 'Coveltica, sans-serif',
            fontSize: '60px', // Agregar tamaño de fuente
            color: 'white', // Agregar color de fuente
        },
        headerSubTitle: {
            fontWeight: '400', // Agregar negrita al texto
            fontFamily: 'Coveltica, sans-serif',
            fontSize: '34px', // Agregar tamaño de fuente
            color: 'white', // Agregar color de fuente
        },
        headerDivText: {
            fontWeight: '800', // Agregar negrita al texto
            fontFamily: 'Lato, cursive',
            fontSize: '40px', // Agregar tamaño de fuente
            color: 'white', // Agregar color de fuente
        },
        login: {
            fontWeight: '800', // Agregar negrita al texto
            fontFamily: 'Coveltica, sans-serif',
            fontSize: '25px', // Agregar tamaño de fuente
            color: '#821520', // Agregar color de fuente
        },
        formulario: {
            border: 'thick solid #FFFFFF',
            opacity: '0.74',// opacidad del login 
            backgroundColor: '#821520',
        },
        component: {
            background: '#9B1B21',
            color: 'white',
        },
        texto: {
            color: '#9B1B21',
        },
        dividers: {
            fontWeight: '300',
        }
    }
    return (
        <>
            <div className="static-slider-head flex flex-column justify-content-center" style={styles.principal}>
                <Container>
                    <Row className="justify-content-end">
                        <Col lg="12" md="12" className="flex justify-content-center align-items-center h-full">
                            <img src="/logos/letrasx2.png" alt="Imagen de Bienvenida" className="p-3 mt-neg-5" style={{ maxWidth: '90%', maxHeight: '90%', marginTop: '-180px' }} />
                        </Col>
                    </Row>
                </Container>
            </div>
            <Toast ref={toast} />
        </>
    );
}

export default HeaderBanner;
